module.exports = __webpack_public_path__ + "img/box.84995fa6.jpg";